import { Stack } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import ShortageTable from 'components/shortage/ShortageTable'
import { shortagesQuery } from 'hooks/shortage'

export const Route = createFileRoute('/_auth/profile/shortage')({
  beforeLoad: async ({ context: { account, queryClient } }) => {
    const userId = account.id
    return await Promise.all([
      queryClient.ensureQueryData(
        shortagesQuery(userId, {
          columnFilters: [],
          pagination: { pageIndex: 0, pageSize: 5 },
        })
      ),
    ])
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Stack mt="xl">
      <ShortageTable />
    </Stack>
  )
}
